module.exports = __webpack_public_path__ + "static/media/postMaterial.f32f1256.svg";